import { POPUP_KEY_RESTORE_FORM } from "../constant";
import { FORMS_URL, postFetchRequest } from "../store/requests";
import i18n from "../i18nService";
import { formsService } from "./formsService";
import { formsStorage } from "./formsStorage";
import {errorCallback, makeUrl} from "../util";

export const formRestoreService = {
    restoreItem(itemId, notifyItemsList) {
        postFetchRequest(makeUrl([FORMS_URL, itemId, '/?restore=true']), null, notifyItemsList, errorCallback, true);
    },
    getItemTitle(itemId, i18nInstance = i18n) {
        return formsService.getLocalization(i18nInstance.resolvedLanguage, formsStorage.getById(itemId), true, i18nInstance);
    },
    getPopupKey() {
        return POPUP_KEY_RESTORE_FORM;
    },
};
